import { Component, OnInit, OnChanges, AfterViewInit, Input, ViewChild, EventEmitter, Output } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { RouteAction } from "@core/action/action";
import { RoleEnum } from "@core/models/role";
import { ContatoPessoaService } from "@core/services/contato.pessoa.service";
import { MessageService } from "@core/services/message.service";
import { ColumnOrder } from "@core/table/order";
import { EntidadeSharedDataService } from "@modules/entidade/entidade-shared-data.service";
import { PessoaSharedDataService } from "@modules/pessoa/pessoa-shared-data.service";
import { VinculoSharedDataService } from "@modules/vinculo/vinculo-shared-data.service";
import { PaginationComponent } from "@shared/components/pagination/pagination.component";
import { NzButtonSize } from "ng-zorro-antd/button";
import { NzModalService, ModalOptions } from "ng-zorro-antd/modal";
import { BehaviorSubject } from "rxjs";
import { AppSignalDataService } from "src/app/app-signal-data.service";
import { ContatoModalComponent } from "../contato-modal/contato-modal.component";
import { ContatoFormComponent } from "../contato-form/contato-form.component";
import { addFormControls } from "@shared/util/util";
import { NomePaginaEnum } from "@core/models/nome-pagina.enum";

@Component({
  selector: 'app-contato-list',
  templateUrl: './contato-list.component.html',
  styleUrls: ['./contato-list.component.scss']
})
export class ContatoListComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() form!: FormGroup;
  @Input() paginaEntidade: boolean = false;

  @Input() data!: any;
  @Input() nomePagina!: NomePaginaEnum;
  @Input() paginaPessoa: boolean = false;

  @Input() contato: any

  @ViewChild(ContatoFormComponent) contatoFormComponent!: ContatoFormComponent;
  @Output() dadosContatoEmit = new EventEmitter<any>();

  dataSet: any[] = [];
  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;

  contatoFilterForm!: FormGroup;
  roleEnum = RoleEnum;
  columOrder: ColumnOrder | undefined;

  statusContato: any[] = [];
  empresas: any[] = [];
  statusContatos: any[] = [];

  validaDetrans: any;
  size: NzButtonSize = 'large';
  situacoes: any[] = [];
  tiposContato: any[] = [];
  contatosSuperior: any;
  searchChange$ = new BehaviorSubject('');
  optionList: string[] = [];
  gruposEconomico: any[] = [];
  nzpage = 0;
  total = 0;
  nzFilterOption = (): boolean => true;

  loading = false;

  constructor(
    public route: ActivatedRoute,
    private modalService: NzModalService,
    private appSignalDataService: AppSignalDataService,
    private entidadeSharedDataService: EntidadeSharedDataService,
    private pessoaSharedDataService: PessoaSharedDataService,
    private vinculoSharedDataService: VinculoSharedDataService,
    private contatoPessoaService: ContatoPessoaService,
    private messageService: MessageService
  ) {
    this.appSignalDataService.updateCollapsedMenuAside(true);
  }

  ngOnChanges(): void {
    const nomeObs = this.nomePagina + 'Contatos';
    if(this.data && this.data[nomeObs]) {
      const contatos = this.data[nomeObs];
      this.dataSet = contatos;

      if(this.nomePagina === NomePaginaEnum.ENTIDADE) {
        this.paginaEntidade = true;
      }
    }
  }

  ngAfterViewInit(): void {
    this.contatoFormComponent?.contatoEmit.subscribe((res: any) => {
      if (!this.paginaEntidade) {
        const index = this.dataSet.findIndex(item => item.id === res.id);
        if (index !== -1) {
          this.dataSet[index] = res;
          this.enviarContato();
        } else {
          this.dataSet.push(res);
          this.enviarContato();
        }
      } else {
        this.dataSet = [res];
        this.enviarContato();
      }
    });

    this.entidadeSharedDataService?.resetForm$.subscribe(res => {
      if (res) {
        this.dataSet = [];
      }
    });

    this.pessoaSharedDataService?.resetForm$.subscribe(res => {
      if (res) {
        this.dataSet = [];
      }
    });

    this.vinculoSharedDataService?.resetForm$.subscribe(res => {
      if (res) {
        this.dataSet = [];
      }
    });
  }

  ngOnInit(): void {
    this.construirForm();
  }

  construirForm() {
    const nomeObs = this.nomePagina + 'Contatos';
    addFormControls(this.form, {
      [nomeObs]: [],
    });
  }

  onSearch(value: string): void {
    this.loading = true;
    this.searchChange$.next(value);
  }

  sort(event: any) {
    const itemSelected = event.sort.find((x: any) => x.value);
    const sortField = itemSelected?.key;
    const sortOrder = itemSelected?.value;

    const sortParams = {
      sortField,
      sortOrder
    };

    if (sortField && sortOrder) {
      this.loadData(sortParams);
    }
  }

  loadData(sortParams?: any): void {
    let params = {};
    if (sortParams) {
      params = { ...sortParams };
    }

    const data = {
      content: this.dataSet,
      totalElements: this.dataSet.length
    };

    if (sortParams?.sortField && sortParams?.sortOrder) {
      data.content.sort((a: any, b: any) => {
        const field = sortParams.sortField;
        const order = sortParams.sortOrder === 'asc' ? 1 : -1;

        if (a[field] < b[field]) {
          return -1 * order;
        }
        if (a[field] > b[field]) {
          return 1 * order;
        }
        return 0;
      });
    }

    this.dataSet = data.content;
    this.paginator.totalItens = data.totalElements;
  }

  showModal(obj?: any): void {
    const config: ModalOptions<ContatoModalComponent> = {
      nzTitle: 'Entidade Contato',
      nzContent: ContatoModalComponent,
      nzCentered: true,
      nzFooter: null,
      nzMaskClosable: false,
      nzWidth: '69vw',
      nzClosable: false
    };
    const modalRef = this.modalService.create(config);
    modalRef.componentInstance!.contato = obj;
    modalRef.componentInstance!.acao = obj ? RouteAction.Editar : RouteAction.Inserir;
    modalRef.componentInstance!.dataSet = this.dataSet;

    modalRef.afterClose.subscribe((result: any) => {
      if (result) {
        if (obj) {
          const index = this.dataSet.findIndex(item => item.id === obj.id);
          this.dataSet[index] = result;
          this.enviarContato();
        } else {
          this.dataSet.push(result);
          this.enviarContato();
        }
      }
    });
  }

  editarItem(obj: any) {
    this.contato = obj;
    const editObj = { ...obj };

    const telefoneSemCodArea = /^\d{4}[- ]?\d{4}$/;
    if(editObj?.telefone){

    if (telefoneSemCodArea.test(editObj?.telefone.trim())) {
      editObj.telefone = `(00) ${editObj.telefone.replace(' ', '-')}`;
    }}

    this.contato = editObj;
  }

  removerContato(obj?: any): void {
    if (this.nomePagina === NomePaginaEnum.PESSOA) {
      this.contatoPessoaService.excluir(obj.id).subscribe(res => {
        this.messageService.success(`contato deletado com sucesso!!!`);
      });
    }
    else {
      const index: number = this.dataSet.indexOf(obj);
      if (index !== -1) {
        this.dataSet.splice(index, 1);
        this.enviarContato();
      }
    }
  }

  enviarContato() {
    const nomeObs = this.nomePagina + 'Contatos';
    this.form.get(nomeObs)?.setValue(this.dataSet);
  }

}
